import { render, staticRenderFns } from "./SplashFindus.vue?vue&type=template&id=252849c1&scoped=true&"
import script from "./SplashFindus.vue?vue&type=script&lang=js&"
export * from "./SplashFindus.vue?vue&type=script&lang=js&"
import style0 from "./SplashFindus.vue?vue&type=style&index=0&id=252849c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252849c1",
  null
  
)

export default component.exports